import React, { useRef, useEffect, useState } from "react";
import { Layout, Row, Col, Button, Card } from "antd";
import { Helmet } from "react-helmet";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NavBar from "../landingPage/header/navbar";
import Footer from "../landingPage/footer";
import MetaTagContents from "../../MetaTagContents";
import TextConstants from "../../TextConstants";
import TrustedByBrands from "../landingPage/TrustedByBrands";
import GetStarted from "../Homepage/GetStarted/GetStarted";
import "./AboutUsNew.scss";
import BrandsCarousel from "../pricingV2/components/BrandsCarousel/BrandsCarousel";
import { trackCta } from "../../analytics";

const { Content } = Layout;

const customerImages = [
  "/ai_creator/pricing_gallery/gallery-img1.jpg",
  "/ai_creator/pricing_gallery/gallery-img2.jpg",
  "/ai_creator/pricing_gallery/gallery-img3.jpg",
  "/ai_creator/pricing_gallery/gallery-img4.jpg",
  "/ai_creator/pricing_gallery/gallery-img5.jpg",
  "/ai_creator/pricing_gallery/gallery-img6.jpg",
  "/ai_creator/pricing_gallery/gallery-img7.jpg",
  "/ai_creator/pricing_gallery/gallery-img8.jpg",
  "/ai_creator/pricing_gallery/gallery-img9.jpg",
  "/ai_creator/pricing_gallery/gallery-img10.jpg",
];

const team = [
  {
    img: '/team/amra.jpg',
    name: 'Amra Tareen',
  },
  {
    img: '/team/kaiser.jpg',
    name: 'Kaiser Pister',
  },
  {
    img: '/team/faizan.jpg',
    name: 'Faizan-ur-Rehman Farooqi',
  },
  {
    img: '/team/mukarram.jpg',
    name: 'Mukarram Shafique',
  },
  {
    img: '/team/david.jpg',
    name: 'David Denenberg',
  },
  {
    img: '/team/susan.jpg',
    name: 'Susan Glen',
  },
  {
    img: '/team/erick.jpg',
    name: 'Erick Goin',
  },
  {
    img: '/team/john.jpg',
    name: 'John Ferry',
  },
]

const values = [
  {
    icon: '/Star.svg',
    title: 'Excellence, Always',
    desc: 'We’re obsessed with quality. From photorealistic 3D renderings to polished final assets, we deliver content that makes every product shine.'
  },
  {
    icon: '/Sound.svg',
    title: 'Empower Every Seller',
    desc: 'We believe high-quality shouldn’t be reserved for big brands. Our platform is built to help anyone—from solo sellers to teams—get to market confidently.'
  },
  {
    icon: '/shapes.svg',
    title: 'Simplicity by Design',
    desc: 'No need to be a 3D expert to succeed here. We’ve designed every part of our platform to be intuitive, fast, and usable by anyone, no training required.'
  }
]



const AboutUsNew = () => {
  const { name, content } = MetaTagContents.ABOUT_US;

  useEffect(() => {
    trackCta('about_page_visit', {});
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{MetaTagContents.ABOUT_US.title}</title>
        <link rel="canonical" href="https://all3d.ai/about-us" />
        <meta name={name} content={content} />
      </Helmet>

      <NavBar />
      <Layout>
        <WebVersion />
        <MobileVersion />
      </Layout>
      <Footer />
    </React.Fragment>
  );
};

const WebVersion = () => {

  let sliderRef = useRef(null);
  const [duplicateImages, setDuplicateImages] = useState(false);


  const next = () => {
    if (sliderRef) {
      sliderRef.slickNext();
    }
  };

  const prev = () => {
    if (sliderRef) {
      sliderRef.slickPrev();
    }
  };


  useEffect(() => {
    setDuplicateImages(true);
  }, []);


  const settings = {
    autoplay: false,
    dots: false,
    infinite: true,
    arrows: false,
    speed: 600,
    slidesToShow: 4.05,
    slidesToScroll: 4,
    vertical: false,

  };

  return (
    <Content className="d-none d-lg-block">
      {/* Hero Section */}
      <Row className="about-hero-section">
        <Col span={24}>
          <div className="manrope f-16 w-500 lh-24 black-085 mb-16">About Us</div>
          <div className="manrope f-50 w-600 lh-60 black-085 mb-24">
            We help sellers create high-quality<br />product imagery that's{" "}
            <span className="manrope blue">faster, easier,<br />and more accurate.</span>
          </div>
          <Button
            className="view-pricing-btn"
            onClick={() => {
              window.location.href = "/pricing"
            }}
          >
            View pricing & plans
          </Button>
        </Col>
      </Row>

      {/* Product Images Carousel */}
      <Row className="pricing-section-wrapper-about">
        <Col span={24} className="pricing-carousel-container">
          <div className="pricing-carousel-wrapper-inner">
            <div className="pricing-carousel__track">
              {customerImages.map((img, index) => (
                <div key={`img-${index}`} className="pricing-carousel__item">
                  <Card className="pricing-image-card" bordered={false}>
                    <img loading="lazy" src={img} alt={`Customer AI ${index + 1}`} className="pricing-customer-img" />
                  </Card>
                </div>
              ))}
              {duplicateImages &&
                customerImages.map((img, index) => (
                  <div key={`img-duplicate-${index}`} className="pricing-carousel__item">
                    <Card className="pricing-image-card" bordered={false}>
                      <img loading="lazy" src={img} alt={`Customer AI ${index + 1}`} className="pricing-customer-img" />
                    </Card>
                  </div>
                ))}
            </div>
          </div>
        </Col>
      </Row>

      {/* AI-Powered Asset Creation */}
      <Row className="ai-asset-section">
        <Col span={14} className="justify-in-center">
          <div className="manrope f-24 w-600 lh-32 black-085 d-block">
            With AI-powered asset creation, we help businesses <span className="manrope blue">bring products to life</span> without the cost or delays of traditional methods.
          </div>
        </Col>
      </Row>

      {/* Kitchen Island Section */}
      <Row className="kitchen-section">
        <Col span={12} className="kitchen-image-col">
          <img src="/landingPage/diningset.png" alt="Kitchen island" className="kitchen-image" />
        </Col>
        <Col span={12} className="kitchen-text-col">
          <p className="manrope f-24 w-600 lh-32 black-085 d-block text-left">
            Using just a product photo and inspiration, sellers can generate, edit, and review images in one streamlined workflow <span className="manrope blue">bringing products to market faster without sacrificing quality or control.</span>
          </p>
        </Col>
      </Row>

      {/* Grass Field Section */}
      <Row className="grass-section">
        <Col span={12} className="grass-text-col">
          <p className="manrope f-24 w-600 lh-32 black-085 d-block text-left">
            <span className="manrope blue">No tool-hopping. No endless revisions.</span> Just a faster, smarter way to create product imagery that looks right and sells better.
          </p>
        </Col>
        <Col span={12} className="grass-image-col">
          <img src="/landingPage/plants.jpg" alt="Grass field" className="grass-image" />
        </Col>
      </Row>

      {/* How ALL3D is Different */}
      <Row className="values-section">
        <Content className="d-none d-lg-block">
          <Row className="container-fluid justify-in-center benefits-section" style={{ paddingTop: 40, paddingBottom: 40 }}>
            <Col span={24} className="justify-in-center text-center">
              <p className="manrope f-16 lh-24 w-500 black-085 mb-16">Our Values</p>
            </Col>
            <Col span={24} className="justify-in-center text-center">
              <h3 className="manrope f-30 lh-40 w-600 black-085 mb-64">How ALL3D is Different</h3>
            </Col>
            {values.map((value, index) => (
              <Col span={8} className="justify-in-center direction-flex coll pd-16">
                <img src={value.icon} alt="" className="mb-16" width={index == 2 ? 80 : 56} height={index == 2 ? 80 : 56} />
                <p className="manrope f-20 w-700 lh-28 black-085 mb-8 text-center">{value.title}</p>
                <p className="manrope f-16 w-400 lh-24 black-085 text-center">{value.desc}</p>
              </Col>

            ))}
          </Row>
        </Content>
      </Row>

      {/* Trusted by Brands */}
      <BrandsCarousel />

      <Content className="d-none d-lg-block">
        <Row className="container-fluid offering-carousel-wrapper">
          <Row className="section-margin-right w-100 direction-flex justify-space-between mb-80">
            <Col span={15}>
              <div
                className="manrope f-50 w-600 lh-60 white text-left"
                style={{ display: "inline-block" }}>
                Meet the team
              </div>
            </Col>
            <Col span={6}>
              <div className="manrope f-16 w-500 lh-24 white text-left">
                Based in San Francisco with teams working together all across the globe
              </div>
            </Col>
          </Row>

          <Col span={24} className="mb-24">
            <Slider ref={slider => {
              sliderRef = slider;
            }} {...settings} className="offering-slider-setting" style={{ height: 411 }}>
              {team.map((member, index) => (
                <div>
                  <Card className="offering-card" bordered={false} style={{ background: 'transparent', paddingLeft: [0, 4, 8].includes(index) ? 10 : 8 }}>
                    <img loading="lazy" src={member.img} alt={member.name} className={`offering-img-dim`} />

                  </Card>
                  <p style={{ paddingLeft: [0, 4, 8].includes(index) ? 10 : 8, marginTop: 24 }} className="manrope f-20 w-600 lh-28 white text-left">{member.name}</p>

                </div>
              ))}
            </Slider>
          </Col>
          {/* </Row> */}
          <Row className="section-margin-right w-100">
            <Col span={12}>
            </Col>
            <Col span={12} className="direction-flex roww justify-in-end">
              <Button onClick={prev}
                icon={<ArrowLeftOutlined className="manrope f-20 lh-0" />}
                className={`slider-btn-ar   mr-24`}
              />
              <Button onClick={next}
                icon={<ArrowRightOutlined className="manrope f-20 lh-0" />}
                className={`slider-btn-ar`}
              />
            </Col>
          </Row>
        </Row>
      </Content>

      {/* Get Started */}
      <Row className="get-started-section">
        <Col span={24}>
          <GetStarted />
        </Col>
      </Row>
    </Content>
  );
};

const MobileVersion = () => {
  let sliderRef = useRef(null);

  const [duplicateImages, setDuplicateImages] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  const settings = {
    autoplay: false,
    dots: false,
    infinite: true,
    arrows: false,
    speed: 600,
    slidesToShow: 1.1,
    slidesToScroll: 1,
    vertical: false,
    initialSlide: 0,
    beforeChange: (current, next) => setActiveSlide(next),
  };

  useEffect(() => {
    setDuplicateImages(true);
  }, []);

  return (
    <Content className="d-lg-none">
      {/* Hero Section */}
      <Row className="about-hero-section mobile">
        <Col span={24}>
          <div className="manrope f-16 w-500 lh-24 black-085 mb-16">About Us</div>
          <div className="manrope f-30 w-600 lh-40 black-085 mb-24">
            We help sellers create high-quality product imagery that's{" "}
            <span className="manrope blue">faster, easier, and more accurate.</span>
          </div>
          <Button
            className="view-pricing-btn mobile"
            onClick={() => window.location.href = "/pricing"}
          >
            View pricing & plans
          </Button>
        </Col>
      </Row>

      {/* Product Images Carousel */}
      <Row className="pricing-section-wrapper-mobile-about">
        <Col span={24} className="pricing-carousel-container">
          <div className="pricing-carousel-wrapper-inner">
            <div className="pricing-carousel__track">
              {customerImages.map((img, index) => (
                <div key={`img-${index}`} className="pricing-carousel__item">
                  <Card className="pricing-image-card" bordered={false}>
                    <img loading="lazy" src={img} alt={`Customer AI ${index + 1}`} className="pricing-customer-img" />
                  </Card>
                </div>
              ))}
              {duplicateImages &&
                customerImages.map((img, index) => (
                  <div key={`img-duplicate-${index}`} className="pricing-carousel__item">
                    <Card className="pricing-image-card" bordered={false}>
                      <img loading="lazy" src={img} alt={`Customer AI ${index + 1}`} className="pricing-customer-img" />
                    </Card>
                  </div>
                ))}
            </div>
          </div>
        </Col>
      </Row>

      {/* AI-Powered Asset Creation */}
      <Row className="ai-asset-section mobile">
        <Col span={24} className="text-center">
          <div className="manrope f-20 w-600 lh-28 black-085 d-block text-left">
            With AI-powered asset creation, we help businesses <span className="manrope blue">bring products to life</span> without the cost or delays of traditional methods.

          </div>
        </Col>
      </Row>

      {/* Kitchen Island Section */}
      <Row className="kitchen-section mobile">
        <Col span={24} className="kitchen-image-col mobile">
          <img src="/landingPage/diningset.png" alt="Kitchen island" className="kitchen-image" />
        </Col>
        <Col span={24} className="kitchen-text-col mobile">
          <div className="manrope f-20 w-600 lh-28 black-085 d-block text-left">
            Using just a product photo and inspiration, sellers can generate, edit, and review images in one streamlined workflow <span className="manrope blue">bringing products to market faster without sacrificing quality or control.</span>
          </div>
        </Col>
      </Row>

      {/* Grass Field Section */}
      <Row className="grass-section mobile">
        <Col span={24} className="grass-image-col mobile">
          <img src="/landingPage/plants.jpg" alt="Grass field" className="grass-image" />
        </Col>
        <Col span={24} className="grass-text-col mobile">
          <div className="manrope f-20 w-600 lh-28 black-085 d-block text-left">
            <span className="manrope blue">No tool-hopping. No endless revisions.</span> Just a faster, smarter way to create product imagery that looks right and sells better.
          </div>
        </Col>
      </Row>

      {/* How ALL3D is Different */}
      <Row className="values-section mobile">
        <Col span={24} className="justify-in-center text-center">
          <p className="manrope f-16 lh-24 w-500 black-085 mb-16">Our Values</p>
        </Col>
        <Col span={24} className="justify-in-center text-center">
          <h3 className="manrope f-30 lh-40 w-600 black-085 mb-64">How ALL3D is Different</h3>
        </Col>
        {values.map((value, index) => (
          <Col span={24} className="justify-in-center direction-flex coll mb-32">
            <img src={value.icon} alt="" className="mb-16" width={index == 2 ? 48 : 40} height={index == 2 ? 80 : 56} />
            <p className="manrope f-20 w-700 lh-28 black-085 mb-8 text-center">{value.title}</p>
            <p className="manrope f-16 w-400 lh-24 black-085 text-center">{value.desc}</p>
          </Col>
        ))}
      </Row>

      <BrandsCarousel />

      {/* Meet the Team */}
      <Content className="d-lg-none">
        <Row className="container-fluid offering-carousel-wrapper">
          <Row className="section-margin-right w-100 direction-flex justify-space-between mb-24">
            <Col span={24} className='mb-16'>
              <div
                className="manrope f-38 w-600 lh-46 white text-left"
                style={{ display: "inline-block" }}>
                Meet the team
              </div>
            </Col>
            <Col span={24}>
              <div className="manrope f-16 w-500 lh-24 white text-left mb-24">
                Based in San Francisco with teams working together all across the globe
              </div>
            </Col>
          </Row>
          <Col span={24} className="mb-24">
            <Slider ref={slider => {
              sliderRef = slider;
            }} {...settings} className="offering-slider-setting" style={{ height: 411 }}>
              {team.map((member, index) => (
                <>
                  <Card className="offering-card" key={index} bordered={false} style={{ background: 'transparent', paddingLeft: index === activeSlide ? 36 : 8 }}>
                    <img loading="lazy" src={member.img} alt={member.name} className={`offering-img-dim`} />
                    <div className="manrope f-20 w-600 lh-28 white text-left" style={{ marginTop: 24 }}>{member.name}</div>
                  </Card>
                </>
              ))}
            </Slider>
          </Col>

        </Row>
      </Content>

      {/* Get Started */}
      <Row className="get-started-section mobile">
        <Col span={24}>
          <GetStarted />
        </Col>
      </Row>
    </Content>
  );
};

export default AboutUsNew;
